(async () => {
    const { Core } = await importModule('Core');
    const { $replaceContent, $toggleDisplay } = await importModule('Utils');

    customElements.define('x-cart', class extends Core {
        elements = {
            itemsContainer: '[data-cart-items-container]',
            emptyMsg: '[data-cart-empty]',
            items: '[data-cart-items]',
            subtotalBlock: '[data-cart-subtotal-block]'
        }
        
        subscriptions = {
            'cart:update': '_onUpdate',
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'cart' });
            this.subscribe('cart:update', { global: true });
        };

        _onUpdate({ cart }) {
            if (!cart) return;
            const hasCartItems = cart.getCount() > 0;
            this._toggleView(hasCartItems);
            hasCartItems && this._updateItems(cart);
        }

        _toggleView(state) {
            $toggleDisplay(this.$emptyMsg, !state)
            $toggleDisplay(this.$itemsContainer, state)
        }

        _updateItems({ getItems, getSubtotalBlock }) {
            $replaceContent(this.$subtotalBlock, getSubtotalBlock());
            $replaceContent(this.$items, getItems());
        }
    });
})();

// Countdown from 10 minutes
  function startCountdown(duration, display) {
    let timer = duration, minutes, seconds;
    const intervalId = setInterval(() => {
      minutes = Math.floor(timer / 60);
      seconds = timer % 60;

      // Format with leading zeros if needed
      const minutesStr = minutes < 10 ? "0" + minutes : minutes;
      const secondsStr = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = minutesStr + ":" + secondsStr;

      // Stop when timer reaches zero
      if (--timer < 0) {
        clearInterval(intervalId);
        display.textContent = "00:00";
      }
    }, 1000);
  }

  window.onload = () => {
    const tenMinutes = 60 * 10; // 10 minutes in seconds
    const display = document.getElementById("countdown-timer");
    startCountdown(tenMinutes, display);
  };